import joi, { optional } from '@hapi/joi';
import {
    KYCDocumentDetails,
} from './types';



export const KYCDocumentSchema = joi
    .object<KYCDocumentDetails>()
    .unknown(true)
    .keys({
        AmountIncome: joi
            .string()
            .required()
            .error((err: any) => 'Annual Income is required'),
        DeclaredNaturalPerson: joi.boolean().invalid(false).error((err: any) => 'You must declare that you agree with Account For Natural Persons clause'),
        Saving: joi.boolean().optional(),
        ProceedSales: joi.boolean().optional(),
        Other: joi.boolean().optional(),
    });
